<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0px;
  padding: 0px;
}

body{
  overflow-y: scroll;
}
.el-tooltip__popper{
  max-width: 300px;
  line-height: 180%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue